"use client";

import { useState } from "react";
import toast from "react-hot-toast";
import { useRouter } from "next/navigation";
import { TableActionCell } from "@/ui";
import ConfirmDialog from "@components/shared/ConfirmDialog";

export default function MoreMenu({ float, onDuplicate, onDelete }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const router = useRouter();

  const handleView = () => {
    router.push(`/floats/${float.uuid}`);
  };

  const handleEdit = () => {
    router.push(`/floats/${float.uuid}/edit`);
  };

  const handleDuplicate = () => {
    onDuplicate(float.uuid);
  };

  const handleViewInteractive = () => {
    window.open(`/show/${float.uuid}?p=1`, "_blank");
  };

  const handleDelete = () => {
    setConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    setConfirmOpen(false);
    onDelete(float.uuid);
    toast.success("Float deleted");
  };

  return (
    <>
      <TableActionCell
        items={[
          { label: "Edit", onClick: handleEdit },
          { label: "View activity", onClick: handleView },
          { label: "Duplicate", onClick: handleDuplicate },
          { label: "View interactive page", onClick: handleViewInteractive },
          { label: "Delete", onClick: handleDelete, destructive: true },
        ]}
      />
      <ConfirmDialog
        title="Delete float"
        message="Are you sure you want to delete this float?"
        open={confirmOpen}
        onConfirm={handleConfirmDelete}
        onClose={() => setConfirmOpen(false)}
      />
    </>
  );
}
